import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#1a1a1a] text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          <div>
            <h3 className="text-4xl font-bold mb-4">Giletau</h3>
            <p className="text-gray-400 text-sm mb-6 max-w-sm leading-relaxed">
              Comprendre avant d'acheter. Guide indépendant pour aider les consommateurs à faire des choix éclairés et éviter les pièges du commerce en ligne.
            </p>
            <div className="flex gap-4">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border border-gray-600 flex items-center justify-center hover:border-white transition-colors cursor-pointer"
              >
                <i className="ri-facebook-line text-lg"></i>
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border border-gray-600 flex items-center justify-center hover:border-white transition-colors cursor-pointer"
              >
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border border-gray-600 flex items-center justify-center hover:border-white transition-colors cursor-pointer"
              >
                <i className="ri-linkedin-line text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm uppercase text-gray-400 mb-6 font-semibold tracking-wide">
              Navigation
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-white hover:text-gray-300 transition-colors cursor-pointer">
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-white hover:text-gray-300 transition-colors cursor-pointer">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/a-propos" className="text-white hover:text-gray-300 transition-colors cursor-pointer">
                  À propos
                </Link>
              </li>
              <li>
                <Link to="/methodologie-independance" className="text-white hover:text-gray-300 transition-colors cursor-pointer">
                  Méthodologie
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-white hover:text-gray-300 transition-colors cursor-pointer">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm uppercase text-gray-400 mb-6 font-semibold tracking-wide">
              Informations légales
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/mentions-legales" className="text-white hover:text-gray-300 transition-colors cursor-pointer">
                  Mentions légales
                </Link>
              </li>
              <li>
                <Link to="/politique-confidentialite" className="text-white hover:text-gray-300 transition-colors cursor-pointer">
                  Politique de confidentialité
                </Link>
              </li>
              <li>
                <Link to="/politique-cookies" className="text-white hover:text-gray-300 transition-colors cursor-pointer">
                  Politique cookies
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-center items-center">
            <p className="text-gray-500 text-xs">
              © {currentYear} Giletau — Tous droits réservés
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
